import {
  GraduationCapIcon,
  ClipboardListIcon,
  HeartPulseIcon,
  SirenIcon,
  ClipboardCheckIcon,
  PresentationIcon,
  BookOpenIcon,
  GiftIcon,
  FileCheck2Icon,
  ListChecksIcon,
  ImageIcon,
  FolderKanbanIcon,
  ScaleIcon,
  LibraryIcon,
  MousePointerClickIcon,
  UsersIcon,
  WorkflowIcon,
  type LucideIcon,
} from 'lucide-react';

export const BRAND = 'Ebook Store';
export const CHECKOUT_URL = 'https://primeros-auxilios-para-instructores.impultienda.ar/checkout';
export const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/9ky6JWVm7eZrSjYEH4mink/Diseno_sin_titulo_(65).png';
export const PRODUCT_IMAGE_SIZE = { width: 1330, height: 1290 };
export const PRICE = '$19.990 ARS';
export const CORE_PROMISE = 'Tu próxima capacitación no empieza desde cero.';

export type Crop = { x: number; y: number; w: number; h: number };

export const heroPillars: { label: string; icon: LucideIcon }[] = [
  { label: 'Método para enseñar', icon: GraduationCapIcon },
  { label: 'Protocolos', icon: ClipboardListIcon },
  { label: 'Maniobras', icon: HeartPulseIcon },
  { label: 'Simulaciones', icon: SirenIcon },
  { label: 'Evaluaciones', icon: ClipboardCheckIcon },
  { label: 'Clases listas', icon: PresentationIcon },
];

export const quickStats = [
  { value: '3', label: 'Volúmenes completos' },
  { value: '5', label: 'Bonos prácticos' },
  { value: '25', label: 'Escenarios de simulación' },
  { value: '10', label: 'Clases listas para adaptar' },
];

export const painCards = [
  'Preparando contenidos desde distintas fuentes.',
  'Buscando actividades para que tus alumnos practiquen.',
  'Inventando escenarios de emergencia desde cero.',
  'Armando evaluaciones para cada curso.',
  'Diseñando material visual para tus alumnos.',
  'Organizando planillas, asistencia y seguimiento.',
];

export const agitationPoints = [
  'Sabés la maniobra, pero explicarla requiere otra preparación.',
  'Improvisás preguntas o situaciones prácticas.',
  'Preparar una evaluación es todavía más trabajo.',
  'Terminás con apuntes, videos y manuales abiertos a la vez.',
];

export const solutionItems = [
  'Qué enseñar',
  'En qué orden enseñarlo',
  'Cómo demostrarlo',
  'Qué errores observar',
  'Cómo organizar las prácticas',
  'Qué escenario utilizar',
  'Cómo evaluar y corregir',
  'Clases completas para adaptar',
];

export const solutionCycle = ['Prepará', 'Enseñá', 'Entrená', 'Evaluá', 'Mejorá'];

export const volumeBenefits: { title: string; body: string; icon: LucideIcon }[] = [
  { title: 'Contenido organizado', body: 'Para consultar antes o durante la preparación de tus capacitaciones.', icon: LibraryIcon },
  { title: 'Orientación práctica', body: 'No solamente qué enseñar, sino cómo llevarlo al aula.', icon: MousePointerClickIcon },
  { title: 'Enfoque para instructores', body: 'Pensado desde la enseñanza y no únicamente desde la teoría.', icon: UsersIcon },
  { title: 'Sistema conectado', body: 'Los tres volúmenes trabajan como partes de un mismo proceso.', icon: WorkflowIcon },
];

export const showcaseIndicators: { label: string; icon: LucideIcon }[] = [
  { label: '3 volúmenes', icon: BookOpenIcon },
  { label: '5 bonos', icon: GiftIcon },
  { label: '25 escenarios', icon: SirenIcon },
  { label: '10 clases', icon: PresentationIcon },
  { label: 'Evaluaciones', icon: FileCheck2Icon },
  { label: 'Rúbricas', icon: ScaleIcon },
  { label: 'Checklists', icon: ListChecksIcon },
  { label: 'Recursos visuales', icon: ImageIcon },
  { label: 'Herramientas de gestión', icon: FolderKanbanIcon },
];

export const audienceItems = [
  'Sos instructor de primeros auxilios y querés organizar mejor tu material.',
  'Estás empezando y necesitás una estructura clara.',
  'Querés reducir el tiempo que dedicás a preparar clases.',
  'Querés sumar simulaciones y evaluación a tus capacitaciones.',
  'Buscás una imagen más profesional frente a tus alumnos.',
];

export const withoutSystem = [
  'Buscar información cada vez',
  'Crear prácticas desde cero',
  'Inventar escenarios',
  'Preparar nuevas evaluaciones',
  'Diseñar material visual',
  'Organizar documentos dispersos',
  'Volver a empezar en el próximo curso',
];

export const withSystem = [
  'Método organizado',
  'Protocolos reunidos',
  'Escenarios disponibles',
  'Evaluaciones preparadas',
  'Clases estructuradas',
  'Recursos visuales',
  'Herramientas de gestión',
];

export const offerIncludes = ['Los 3 volúmenes', 'Los 5 bonos', 'Acceso al material digital'];

export const hiddenCosts = [
  'Horas buscando material',
  'Horas armando actividades',
  'Horas diseñando evaluaciones',
  'Horas creando recursos',
  'Horas reorganizando información',
];

export const faqs = [
  {
    q: '¿El sistema es solamente para instructores con experiencia?',
    a: 'No. Puede utilizarse tanto como estructura para quien está comenzando como material de apoyo para quien ya dicta capacitaciones.',
  },
  { q: '¿Cómo recibo el material?', a: 'El acceso es digital después de completar la compra.' },
  {
    q: '¿Puedo adaptar las clases?',
    a: 'Sí. Las clases y recursos están pensados para que puedas ajustarlos a tu grupo, duración y modalidad de capacitación.',
  },
  {
    q: '¿Incluye material práctico?',
    a: 'Sí. El sistema incorpora escenarios, clases, evaluaciones, checklists, recursos visuales y herramientas de organización.',
  },
  { q: '¿Los bonos están incluidos en el precio?', a: 'Sí. Los 5 bonos forman parte del sistema completo de $19.990 ARS.' },
  { q: '¿Es un pago único?', a: 'Sí. El precio indicado corresponde a un único pago.' },
];

export const recentBuyers = [
  { name: 'Mariana López', city: 'Córdoba' },
  { name: 'Lucas Fernández', city: 'Rosario' },
  { name: 'Sofía Martínez', city: 'Mendoza' },
  { name: 'Martín Gómez', city: 'La Plata' },
  { name: 'Valeria Díaz', city: 'San Miguel de Tucumán' },
  { name: 'Diego Romero', city: 'Mar del Plata' },
  { name: 'Carolina Sosa', city: 'Salta' },
  { name: 'Federico Álvarez', city: 'Neuquén' },
  { name: 'Lorena Torres', city: 'Santa Fe' },
  { name: 'Pablo Ruiz', city: 'Bahía Blanca' },
  { name: 'Gabriela Benítez', city: 'Posadas' },
  { name: 'Nicolás Herrera', city: 'Buenos Aires' },
  { name: 'Florencia Castro', city: 'Corrientes' },
  { name: 'Javier Medina', city: 'San Juan' },
  { name: 'Natalia Acosta', city: 'Resistencia' },
  { name: 'Sebastián Molina', city: 'Río Cuarto' },
];

export const launchOffer = {
  hours: 17,
  priceIncrease: '$10.000 ARS',
  spotsTakenPercent: 72,
};

export const testimonials = [
  {
    initials: 'MG',
    quote: 'Organicé todas mis capacitaciones del año en una tarde. Las fichas de seguimiento me ahorran horas cada semana.',
    author: 'Marcela G., Córdoba',
  },
  {
    initials: 'LP',
    quote: 'Los escenarios de simulación cambiaron mis clases. Mis alumnos practican situaciones reales y yo evalúo con criterio. Vale cada peso.',
    author: 'Laura P., Rosario · Instructora de RCP',
  },
  {
    initials: 'RM',
    quote: 'Mis prácticas grupales dejaron de ser un caos. El sistema de estaciones es un antes y un después.',
    author: 'Roberto M., Buenos Aires',
  },
];